import React, { Component } from 'react';
import moment from 'moment';
import { connect } from 'react-redux';
import { FadeLoader } from 'react-spinners';
import { fetchFiliales, fetchFamilia, fetchLugaresEntrega, loadMantenimiento } from '../../actions';
import PageHeader from '../../components/PageHeader';
import Alert from '../../components/Alert';
import Paginacion from '../../components/Paginacion';
import Filtros from './Filtros';
import TablaMantenimiento from './TablaMantenimiento';
import Formulario from './Formulario';
import toggleDiv from '../../utils/toggleDiv';
import { createLugarEntrega, editLugarEntrega } from '../../utils/mantenimientoEntrega';

class MatLugarEntrega extends Component {
  constructor(props) {
    super(props);
    this.state = {
      filial: '',
      familia: '',
      alertErrorOpen: false,
      alertSuccessOpen: false,
      // Paginacion
      pagina: 1,
      totalRegistros: 0,
      cantidad: 0,
      // modal
      modalOpen: '',
      modalTitle: 'Crear registro',
      familiaFormulario: '',
      filialFormulario: '',
      unidadesFormulario: '',
      unidadMaxFormulario: '',
      horaInicio: '',
      horaInicioMax: '',
      horaInicioBloqueo: '',
      horaFinBloqueo: '',
      horasReservadas: '',
      cantidadParalelo: '',
      indParalelo: false,
      indInactivo: false,
      disabledSelects: false,
      registroSelected: '',
      flota: false,
      indSabado:false,
      indDomingo:false,
    };
  }

  componentDidMount() {
    document.addEventListener('click', toggleDiv, true);
    this.props.fetchLugaresEntrega()
      .then(({ payload: { data } }) => this.setState({ totalRegistros: data.totalRegistros,
        cantidad: data.mantLugarEntrega.length }));
    this.props.fetchFiliales();
    this.props.fetchFamilia();
  }

  componentWillUnmount() {
    document.removeEventListener('click', toggleDiv, true);
  }

  onChangeGroup = (e, group) => {
    const array = this.state[group];
    if (array.indexOf(e.target.value)>=0) {
      this.setState({ [group]: array.filter(item => item !== e.target.value) });
    } else {
      this.setState({ [group]: [...array, e.target.value] });
    }
  }

  onChangeValue = e => this.setState({ [e.target.name]: e.target.value });
  onCheck = e => this.setState({ [e.target.name]: e.target.checked });

  onChangeAndFilter = (e) => {
    this.setState(
      { [e.target.name]: e.target.value },
      () => {
        this.props.loadMantenimiento();
        this.props.fetchLugaresEntrega(this.state.familia, this.state.filial)
          .then(({ payload: { data } }) => this.setState({ totalRegistros: data.totalRegistros,
            cantidad: data.mantLugarEntrega.length,
            pagina: 1 }));
      }
    );
  }

  openModalWithValues = (modal, mantenimiento) => {
    this.setState({
      modalOpen: modal,
      familiaFormulario: mantenimiento.codFamVeh || '',
      filialFormulario: mantenimiento.codFilial || '',
      unidadesFormulario: mantenimiento.codTipoDia || '',
      unidadMaxFormulario: mantenimiento.canMaxiUni || '',
      horaInicio: mantenimiento.horaIniEntr ? moment(mantenimiento.horaIniEntr).format('HH:mm') : '',
      horaInicioMax: mantenimiento.horaMaxEntr ? moment(mantenimiento.horaMaxEntr).format('HH:mm') : '',
      horaInicioBloqueo: mantenimiento.horaIniLocked ? moment(mantenimiento.horaIniLocked).format('HH:mm') : '',
      horaFinBloqueo: mantenimiento.horaFinLocked ? moment(mantenimiento.horaFinLocked).format('HH:mm') : '',
      horasReservadas: mantenimiento.numHorasReservada || '',
      cantidadParalelo: mantenimiento.cantVehParalelo || '',
      indParalelo: mantenimiento.indParalelo === 'S',
      flota: mantenimiento.indFlota === 'S',
      indInactivo: mantenimiento.indInactivo === 'N',
      indSabado:mantenimiento.indSabado === 'S',
      indDomingo:mantenimiento.indDomingo === 'S',
      disabledSelects: true,
      registroSelected: mantenimiento.codConfPlanEntr,
      modalTitle: 'Editar registro',
    });
  }

  createRegistro = () => {
    createLugarEntrega(this.state)
      .then((response) => {
        if (response.estadoTrama === '1') {
          this.showAlert('alertSuccessOpen');
          this.props.loadMantenimiento();
          this.props.fetchLugaresEntrega(this.state.familia, this.state.filial)
            .then(({ payload: { data } }) => this.setState({ totalRegistros: data.totalRegistros,
              cantidad: data.mantLugarEntrega.length,
              pagina: 1 }));
        } else {
          this.showAlert('alertErrorOpen');
        }

        this.resetForm();
      });
  }

  editRegistro = (registro) => {
    editLugarEntrega(this.state, registro)
      .then((response) => {
        if (response.data.estadoTrama === '1') {
          this.showAlert('alertSuccessOpen');
          this.props.loadMantenimiento();
          this.props.fetchLugaresEntrega(this.state.familia, this.state.filial)
          .then(({ payload: { data } }) => this.setState({ totalRegistros: data.totalRegistros,
            cantidad: data.mantLugarEntrega.length,
            pagina: 1 }));
        } else {
          this.showAlert('alertErrorOpen');
        }
        this.resetForm();
      });
  }

  closeAlertError = () => this.setState({ alertErrorOpen: false });
  closeAlertSuccess = () => this.setState({ alertSuccessOpen: false });

  showAlert = (alertType) => {
    this.setState({ [alertType]: true });
    setTimeout(() => this.setState({ [alertType]: false }), 5000);
  }

  backPag = () => {
    if (this.state.pagina === 1) return;
    this.setState(
      { pagina: this.state.pagina - 1 },
      () => {
        this.props.loadMantenimiento();
        this.props.fetchLugaresEntrega(this.state.familia, this.state.filial, this.state.pagina)
          .then(({ payload: { data } }) => this.setState({ totalRegistros: data.totalRegistros,
            cantidad: data.mantLugarEntrega.length }));
      }
    );
  }

  nextPag = () => {
    if (this.state.pagina * 10 > this.state.totalRegistros) return;
    this.setState(
      { pagina: this.state.pagina + 1 },
      () => {
        this.props.loadMantenimiento();
        this.props.fetchLugaresEntrega(this.state.familia, this.state.filial, this.state.pagina)
          .then(({ payload: { data } }) => this.setState({ totalRegistros: data.totalRegistros,
            cantidad: data.mantLugarEntrega.length }));
      }
    );
  }

  reset = () => {
    this.setState({
      filial: '',
      familia: '',
    });
    this.props.loadMantenimiento();
    this.props.fetchLugaresEntrega()
      .then(({ payload: { data } }) => this.setState({ totalRegistros: data.totalRegistros,
        cantidad: data.mantLugarEntrega.length,
        pagina: 1 }));
  }

  resetForm = () => {
    this.setState({
      modalOpen: '',
      modalTitle: 'Crear registro',
      familiaFormulario: '',
      filialFormulario: '',
      unidadesFormulario: '',
      unidadMaxFormulario: '',
      horaInicio: '',
      horaInicioMax: '',
      horaInicioBloqueo: '',
      horaFinBloqueo: '',
      horasReservadas: '',
      cantidadParalelo: '',
      indParalelo: false,
      indInactivo: false,
      disabledSelects: false,
      registroSelected: '',
      flota: false,
      indSabado:false,
      indDomingo:false,
    });
  }

  closeModal = () => this.setState({ modalOpen: '' });
  openModal = modal => this.setState({ modalOpen: modal });

  render() {
    const { mantenimientoEntrega, filiales, familias } = this.props;

    return (
      <div>
        <PageHeader title='Mantenimiento de Lugares de entrega' openModal={this.openModal} buttonName='Nuevo registro' modalName='mantenimiento' />
        <Filtros
          familias={familias}
          familia={this.state.familia}
          filiales={filiales}
          filial={this.state.filial}
          onChangeAndFilter={this.onChangeAndFilter}
          reset={this.reset}
        />
        <Paginacion
          paginas={this.state.totalRegistros}
          pagina={this.state.pagina}
          cantidad={this.state.cantidad}
          backPag={this.backPag}
          nextPag={this.nextPag}
        />
        <div className='wrapper'>
          <div className='tableWrapper'>
            <table className='table table-hover' style={{ marginBottom: '20px' }} >
              <thead className='table-head'>
                <tr>
                  <th>ID</th>
                  <th>Familia</th>
                  <th>Filial</th>
                  <th>Ind. de flota</th>
                  <th>Cant. max. de unidades</th>
                  <th>Tipo de Unidad</th>
                  <th>Hora inicio de entregas</th>
                  <th>Hora fin de entregas</th>
                  <th>Hora inicio de bloqueo para entregas</th>
                  <th>Hora fin de bloqueo para entregas</th>
                  <th>Num. horas reservadas para la entrega</th>
                  <th>Ind. en paralelo</th>
                  <th>Cant. de vehículo en paralelo</th>
                  <th>Ind. de inactividad</th>
                  <th />
                </tr>
              </thead>
              {
                mantenimientoEntrega ?
                  <TablaMantenimiento
                    lugares={mantenimientoEntrega.mantLugarEntrega}
                    openModal={this.openModalWithValues}
                  /> :
                  <tbody>
                    <tr>
                      <td colSpan={15}><FadeLoader color={'#F8A14A'} loading /></td>
                    </tr>
                  </tbody>
              }
            </table>
          </div>
        </div>
        <Formulario
          isOpen={this.state.modalOpen === 'mantenimiento'}
          title={this.state.modalTitle}
          closeModal={this.resetForm}
          onChangeValue={this.onChangeValue}
          create={this.createRegistro}
          edit={this.editRegistro}
          familias={familias}
          filiales={filiales}
          familiaFormulario={this.state.familiaFormulario}
          filialFormulario={this.state.filialFormulario}
          flota={this.state.flota}
          unidadesFormulario={this.state.unidadesFormulario}
          unidadMaxFormulario={this.state.unidadMaxFormulario}
          disabled={this.state.disabledSelects}
          registroSelected={this.state.registroSelected}
          onCheck={this.onCheck}
          horaInicio={this.state.horaInicio}
          horaInicioMax={this.state.horaInicioMax}
          horaInicioBloqueo={this.state.horaInicioBloqueo}
          horaFinBloqueo={this.state.horaFinBloqueo}
          horasReservadas={this.state.horasReservadas}
          cantidadParalelo={this.state.cantidadParalelo}
          indParalelo={this.state.indParalelo}
          indInactivo={this.state.indInactivo}
          indSabado = {this.state.indSabado}
          indDomingo = {this.state.indDomingo}
        />
        {
          this.state.alertErrorOpen &&
            <Alert type='alert-warning' icon='ion-alert-circled' closeAlert={this.closeAlertError}>
              <p>Hubo un error al guardar el registro</p>
            </Alert>
        }
        {
          this.state.alertSuccessOpen &&
            <Alert type='alert-success' icon='ion-checkmark-circled' closeAlert={this.closeAlertSuccess}>
              <p>Se guardó correctamente el registro</p>
            </Alert>
        }
        {
          (mantenimientoEntrega && mantenimientoEntrega.error) &&
            <Alert type='alert-danger' icon='ion-alert-circled'>
              <p>{mantenimientoEntrega.mensaje}</p>
            </Alert>
        }
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    filiales: state.filiales,
    familias: state.familias,
    mantenimientoEntrega: state.mantenimientoEntrega,
  };
}

MatLugarEntrega.defaultProps = {
  familias: [],
  filiales: [],
};

export default connect(
  mapStateToProps,
  { fetchFiliales, fetchFamilia, fetchLugaresEntrega, loadMantenimiento }
)(MatLugarEntrega);



// WEBPACK FOOTER //
// ./src/pages/MantLugarEntrega/MantLugarEntrega.js